import { useState } from "react"
import { X } from "lucide-react"
import { motion, AnimatePresence } from "framer-motion"
import { createModel } from "../../api/models/post"
import { useStore } from "../../context/StoreContext"

type Props = {
    currentStore: any
    isOpen: boolean
    onClose: () => void
    //  onAdd: (model: any) => void
    onCreated: (model: any) => void
    existingModels: string[]
}

export default function AddModelModal({
    currentStore,
    isOpen,
    onClose,
    // onAdd,
    onCreated,
    existingModels,
}: Props) {
    const [name, setName] = useState("")
    const [brand, setBrand] = useState("")
    const [category, setCategory] = useState("PHONE")
    const [defaultBuyPrice, setDefaultBuyPrice] = useState("")
    const [error, setError] = useState("")
    const [loading, setLoading] = useState(false)

    // const { currentStore } : any = useStore()
    // console.log({currentStore});
    //   const handleSubmit = () => {
    //     if (!name || !brand || !defaultBuyPrice) {
    //       setError("Veuillez remplir tous les champs obligatoires")
    //       return
    //     }

    //     if (existingModels.includes(name.toLowerCase())) {
    //       setError("Ce modèle existe déjà")
    //       return
    //     }

    //     onAdd({
    //       id: Date.now().toString(),
    //       name,
    //       brand,
    //       category,
    //       defaultBuyPrice: Number(defaultBuyPrice),
    //       createdAt: new Date().toISOString(),
    //     })

    //     // reset
    //     setName("")
    //     setBrand("")
    //     setCategory("PHONE")
    //     setDefaultBuyPrice("")
    //     setError("")
    //     onClose()
    //   }

    const handleSubmit = async () => {
        setError("")

        if (!name || !brand || !defaultBuyPrice) {
            setError("Veuillez remplir tous les champs")
            return
        }

        if (existingModels.includes(name.toLowerCase().replaceAll(" ", ""))) {
            setError("Ce modèle existe déjà")
            return
        }

        try {
            setLoading(true)

            const res = await createModel({
                name,
                brand,
                category,
                defaultBuyPrice: Number(defaultBuyPrice),
                storeId: currentStore?._id
            })

            onCreated(res.data)

            // reset
            setName("")
            setBrand("")
            setCategory("PHONE")
            setDefaultBuyPrice("")
            onClose()
        } catch (e: any) {
            setError(e.response?.data?.message || "Erreur serveur")
        } finally {
            setLoading(false)
        }
    }

    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                >
                    <motion.div
                        className="bg-white rounded-2xl shadow-xl w-full max-w-md p-6 space-y-6"
                        initial={{ scale: 0.9, y: 40 }}
                        animate={{ scale: 1, y: 0 }}
                        exit={{ scale: 0.9, y: 40 }}
                        transition={{ duration: 0.25 }}
                    >
                        {/* Header */}
                        <div className="flex justify-between items-center">
                            <h2 className="text-lg font-semibold text-gray-800">
                                Ajouter un modèle
                            </h2>
                            <button
                                onClick={onClose}
                                className="p-1 rounded hover:bg-gray-100"
                            >
                                <X />
                            </button>
                        </div>

                        {/* Error */}
                        {error && (
                            <div className="bg-red-50 text-red-600 text-sm p-2 rounded-lg">
                                {error}
                            </div>
                        )}

                        {/* Form */}
                        <div className="space-y-4">

                            <div>
                                <label className="text-sm text-gray-600">
                                    Nom du modèle *
                                </label>
                                <input
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    placeholder="Ex: iPhone 13"
                                    className="w-full border rounded-xl px-3 py-2 focus:ring-2 focus:ring-blue-500"
                                />
                            </div>

                            <div>
                                <label className="text-sm text-gray-600">
                                    Marque *
                                </label>
                                <input
                                    value={brand}
                                    onChange={(e) => setBrand(e.target.value)}
                                    placeholder="Ex: Apple"
                                    className="w-full border rounded-xl px-3 py-2 focus:ring-2 focus:ring-blue-500"
                                />
                            </div>

                            <div>
                                <label className="text-sm text-gray-600">
                                    Catégorie *
                                </label>
                                <select
                                    value={category}
                                    onChange={(e) => setCategory(e.target.value)}
                                    className="w-full border rounded-xl px-3 py-2 focus:ring-2 focus:ring-blue-500"
                                >
                                    <option value="PHONE">Téléphone</option>
                                    <option value="COMPUTER">Ordinateur</option>
                                </select>
                            </div>

                            <div>
                                <label className="text-sm text-gray-600">
                                    Prix d’achat par défaut (FCFA) *
                                </label>
                                <input
                                    type="number"
                                    value={defaultBuyPrice}
                                    onChange={(e) => setDefaultBuyPrice(e.target.value)}
                                    placeholder="Ex: 350000"
                                    className="w-full border rounded-xl px-3 py-2 focus:ring-2 focus:ring-blue-500"
                                />
                            </div>

                        </div>

                        {/* Actions */}
                        <div className="flex justify-end gap-3 pt-2">
                            <button
                                onClick={onClose}
                                className="px-4 py-2 rounded-xl border hover:bg-gray-50"
                            >
                                Annuler
                            </button>
                            <button
                                onClick={handleSubmit}
                                className="px-4 py-2 rounded-xl bg-blue-600 text-white hover:bg-blue-700"
                            >
                                Enregistrer
                            </button>
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    )
}
